import { CutPipe } from '../../shared/pipes/cut.pipe';

export function cut ( cutPipe : CutPipe ) {
  return ( value : string, wordwise : boolean, max : any, tail : string ) : string => cutPipe.transform(value, wordwise, max, tail);
}
